<template>
  <div class="title-container">
    <div v-if="enTitle" class="en-title">{{enTitle}}</div>
    <div class="title" :style="{ marginTop: enTitle ? 22 :0 }">{{title}}</div>
    <div v-if="subTitle" class="sub-title">{{subTitle}}</div>
  </div>
</template>

<script>

export default {
  props: {
    enTitle: [String],
    title: [String],
    subTitle: [String]
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.title-container {
  position: relative;
  display: inline-block;
  padding: 0 38px;
  .en-title {
    white-space: nowrap;
    position: absolute;
    top: -22px;
    opacity: 0.03;
    font-family: DINAlternate-Bold;
    font-size: 48px;
    color: #171920;
    text-align: center;
    line-height: 40px;
    font-weight: 700;
    left: 50%;
    transform: translateX(-50%);
  }
  .title {
    font-family: PingFangSC-Semibold;
    font-size: 28px;
    color: #161823;
    font-weight: 600;
  }
  .sub-title {
    margin-top: 20px;
    font-family: PingFangSC-Regular;
    font-size: 16px;
    color: #666666;
    font-weight: 400;
  }
  @media screen and (max-width: 1024px) {
    .en-title {
      font-size: 24px;
      display: none;
    }
    .title {
      font-size: 18px;
    }
    .sub-title {
      font-size: 12px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/CustomTitle.vue